import React, { useState } from "react";
import styled from "styled-components";

import dateService from 'live/services/date'




const ListBody = ({ items, selectUserGroup, deleteObject, company }) => {




  return (
    <Body>
      <div className="list-body">

        <table>
          <thead>
            <tr>
              <th>NAME</th>
              <th>USERS</th>
              <th>LAST CHANGED</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>


            {items.length > 0 ? items.map((group) => {
              return <tr className="list-item" >
                <td onClick={(e) => selectUserGroup(group)}>{group.name ? group.name : "N/A"}</td>
                <td>{group.users ? group.users.length : "N/A"}</td>
                <td>{group.dateModified ? dateService.formatDateTime(group.dateModified) : "N/A"}</td>
                <td>

                  <i class="far fa-edit fa-fw" onClick={(e) => selectUserGroup(group)} />
                  {group.id != company.adminGroupId ?
                    <i class="far fa-trash-alt fa-fw" onClick={(e) => deleteObject(group)} />
                    : null}
                </td>
              </tr>
            }) : null}
          </tbody>
        </table>
      </div>
    </Body>
  );
};

const Body = styled.div`


  .list-body {
    table {
      height:100vh;
      width: 100%;
      
      td,
      th {
        border-bottom: 1px solid #dddee1;
        padding: 5px;
        height: 55px;
        color: #868695;
        width:25vw;
      }

      thead{
        table-layout: fixed;
        border-collapse:collapse;
        background-color: #F5F5F5;
      }

      thead tr{
        display:block;
      }

      tbody{
        height: calc(100% - 242px);
        height: -moz-calc(100% - 242px);
        height: -webkit-calc(100% - 242px);
        height: calc(100% - 242px);
        display:block;
        overflow:auto;
      }

      tbody::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      tbody::-webkit-scrollbar-track {
          border-radius: 10px;
      }

      tbody::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 10px;
      }

      tr {
        :hover {
          cursor: pointer;
          background-color: #ddf0fd;;
        }
      }

      .fa-trash-alt{
        :hover {
          color:red;
        }
      }

      .fa-edit{
        :hover {
          color:blue;
        }
      }
    }
    
  }


`;


export default ListBody;


